import moment from 'moment'
import { TreeSelect } from 'antd'
import { Bar } from 'react-chartjs-2'
import React, { useState } from 'react'
import { Chart as ChartJS, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js'

import { usePet } from '../../../modules'

import DateRangePicker from '../../../components/reusable/rangePicker'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const Process = () => {
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const [routingGroups, setRoutingGroups] = useState([])
    const [category, setCategory] = useState()
    const [filter, setFilter] = useState()
    const [itemGroup, setItemGroup] = useState()
    const [routingGroup, setRoutingGroup] = useState()
    const [reportGroup, setReportGroup] = useState()

    usePet('routingGroups', {}, { notify: true, callback: ({ data }) => setRoutingGroups(data.map(grp => ({
        value: JSON.stringify({ name: grp.name, type: 'Routing Group' }),
        title: grp.name,
        children: grp.categories.map(cat => ({
            value: JSON.stringify({ name: cat, type: 'Routing Group Category' }),
            title: cat,
        })),
    }))) })

    const options2 = {
        indexAxis: 'y',
        elements: {
            bar: {
                borderWidth: 2,
            }
        },
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
            },
            title: {
                display: true,
                text: 'Chart.js Horizontal Bar Chart',
            }
        }
    }

    const hData = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [
            {
                label: 'Dataset 1',
                data: [12, 19, 3, 5, 2, 3],
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            }
        ],
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto h-full overflow-hidden">
            <h2 className='text-xl font-semibold'>Clinical Processes</h2>
            <div className="flex justify-between">              
                <TreeSelect
                    treeLine
                    style={{ width: 300 }}
                    placeholder="Select Filter Criteria"
                    onChange={ val => {
                        if (isNaN(val)) {
                            let json = JSON.parse(val)

                            setItemGroup()
                            setRoutingGroup()
                            setReportGroup()
                            setCategory()

                            switch (json.type) {
                                case 'Report Group':
                                    setReportGroup(json.name)
                                    break
                                    
                                case 'Routing Group':
                                    setRoutingGroup(json.name)
                                    break

                                case 'Item Group':
                                    setItemGroup(json.name)
                                    break

                                default:
                                    setCategory(json.name)
                                    break
                            }

                            // refresh()
                            setFilter(val)
                        }
                    }}
                    value={ filter }
                    treeData={ routingGroups } />
                <DateRangePicker ranges={ranges} selectRange={setRanges} showTime />  
            </div>
            <Bar options={options2} data={hData} />
        </div>
    )
}

export default Process